// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IEeContributionRequestDto
 */
export interface IEeContributionRequestDto {
    /**
     * 
     * @type {number}
     * @memberof IEeContributionRequestDto
     */
    payment_method_id: number;
    /**
     * 
     * @type {string}
     * @memberof IEeContributionRequestDto
     */
    tax_year: string;
    /**
     * 
     * @type {number}
     * @memberof IEeContributionRequestDto
     */
    employee_contribution_amount: number;
    /**
     * 
     * @type {boolean}
     * @memberof IEeContributionRequestDto
     */
    rollover?: boolean;
    /**
     * 
     * @type {string}
     * @memberof IEeContributionRequestDto
     */
    plan_code: string;
}

/**
 * Check if a given object implements the IEeContributionRequestDto interface.
 */
export function instanceOfIEeContributionRequestDto(value: object): value is IEeContributionRequestDto {
    if (!('payment_method_id' in value) || value['payment_method_id'] === undefined) return false;
    if (!('tax_year' in value) || value['tax_year'] === undefined) return false;
    if (!('employee_contribution_amount' in value) || value['employee_contribution_amount'] === undefined) return false;
    if (!('plan_code' in value) || value['plan_code'] === undefined) return false;
    return true;
}

export function IEeContributionRequestDtoFromJSON(json: any): IEeContributionRequestDto {
    return IEeContributionRequestDtoFromJSONTyped(json, false);
}

export function IEeContributionRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IEeContributionRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'payment_method_id': json['payment_method_id'],
        'tax_year': json['tax_year'],
        'employee_contribution_amount': json['employee_contribution_amount'],
        'rollover': json['rollover'] == null ? undefined : json['rollover'],
        'plan_code': json['plan_code'],
    };
}

export function IEeContributionRequestDtoToJSON(json: any): IEeContributionRequestDto {
    return IEeContributionRequestDtoToJSONTyped(json, false);
}

export function IEeContributionRequestDtoToJSONTyped(value?: IEeContributionRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'payment_method_id': value['payment_method_id'],
        'tax_year': value['tax_year'],
        'employee_contribution_amount': value['employee_contribution_amount'],
        'rollover': value['rollover'],
        'plan_code': value['plan_code'],
    };
}

